import React from "react";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { Icon } from "@chakra-ui/react";

function FavouriteIcon({ favourite, ...props }) {
  return favourite ? 
    <Icon {...props} as={FaBookmark} textColor="teal.200" />
  :
    <Icon {...props} as={FaRegBookmark} />
  ;
}

export default FavouriteIcon;